@if (subject) {
  <div class="card">
    <div class="card-header compact">
      <h1 class="ellipsis" [fwTooltip]="subject.label">{{ subject.label || 'No Subject Label' }}</h1>
      <div class="card-actions">
        <app-button-group class="small fill-white">
          @if (permissions.deleteContainer) {
            <button
              aria-label="Delete subject"
              mat-stroked-button
              test-id="delete-button"
              type="button"
              (click)="deleteSubject()"
            >
              <mat-icon class="xs">delete</mat-icon>
            </button>
          }
          @if (permissions.viewAuditTrail) {
            <button
              aria-label="View Subject Audit Trail"
              fwTooltip="View Audit Trail"
              mat-stroked-button
              test-id="view-audit-trail-button"
              type="button"
              (click)="viewAuditTrail()"
            >
              <mat-icon class="xs">list</mat-icon>
            </button>
          }
          <!-- Save managed externally -->
          <!-- <button *ngIf="permissions.editMetadata" test-id="save-button" type="button"
          mat-flat-button color="accent" (click)="saveChanges()" [disabled]="metadata.invalid">
          Save
        </button> -->
          @if (permissions.editMetadata) {
            <button mat-stroked-button test-id="cancel-button" type="button" (click)="resetForm()">Reset</button>
          }
        </app-button-group>
      </div>
    </div>
    <form [formGroup]="metadata">
      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">Label</span>
        <div class="field-value">
          @if (!permissions.editMetadata) {
            <span>{{ subject.label }}</span>
          }
          @if (permissions.editMetadata) {
            <input autocomplete="off" formControlName="label" placeholder="Enter label" test-id="label" type="text" />
          }
        </div>
        <div class="field-error">
          @if (metadata.get('label').hasError('required')) {
            <span>This field is required.</span>
          }
          @if (metadata.get('label').hasError('maxlength')) {
            <span>Entry must be shorter than 64 characters.</span>
          }
        </div>
        <div class="field-action-menu">
          <fw-action-menu fieldKey="label" fieldLabel="Label" test-id="action-menu-label" [auditable]="subject" />
        </div>
      </div>
      <div class="info-row">
        <span class="field-tooltip"></span>
        <span class="field-label">Subject Type</span>
        <div class="field-value">
          @if (!permissions.editMetadata) {
            <span>{{ subject.type | titlecase }}</span>
          }
          @if (permissions.editMetadata) {
            <mat-radio-group aria-label="Select a subject type" formControlName="type">
              @for (option of options.type; track option) {
                <mat-radio-button [attr.test-id]="'radio-button-' + option.value" [value]="option.value">
                  {{ option.label || (option.value | titlecase) }}
                </mat-radio-button>
              }
            </mat-radio-group>
          }
        </div>
        <div class="field-error"></div>
        <div class="field-action-menu">
          <fw-action-menu fieldKey="type" fieldLabel="Subject Type" test-id="action-menu-type" [auditable]="subject" />
        </div>
      </div>
      @if (type === 'human' || !type) {
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">First Name</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.firstname }}</span>
            }
            @if (permissions.editMetadata) {
              <input
                autocomplete="off"
                formControlName="firstname"
                placeholder="Subject First Name"
                test-id="first-name"
                type="text"
              />
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu
              fieldKey="firstname"
              fieldLabel="First Name"
              test-id="action-menu-firstname"
              [auditable]="subject"
            />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Last Name</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.lastname }}</span>
            }
            @if (permissions.editMetadata) {
              <input
                autocomplete="off"
                formControlName="lastname"
                placeholder="Subject Last Name"
                test-id="last-name"
                type="text"
              />
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu
              fieldKey="lastname"
              fieldLabel="Last Name"
              test-id="action-menu-lastname"
              [auditable]="subject"
            />
          </div>
        </div>
      }
      @if (type === 'human' || type === 'animal' || !type) {
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Date of Birth</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.date_of_birth | date: 'yyyy-MM-dd' }}</span>
            }
            @if (permissions.editMetadata) {
              <input
                autocomplete="off"
                class="date-input"
                formControlName="dateOfBirth"
                matInput
                placeholder="YYYY-MM-DD"
                test-id="date-of-birth-input"
                [matDatepicker]="datepicker"
              />
              <mat-datepicker-toggle class="xs" test-id="date-of-birth-toggle" [for]="datepicker">
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #datepicker />
            }
          </div>
          <div class="field-error">
            @if (metadata.get('dateOfBirth').invalid) {
              <span>Must be a valid date.</span>
            }
          </div>
          <div class="field-action-menu">
            <fw-action-menu
              fieldKey="date_of_birth"
              fieldLabel="Date of Birth"
              test-id="action-menu-date-of-birth"
              [auditable]="subject"
            />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">State</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.state | titlecase }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="state" test-id="state">
                <mat-option value="">Select State</mat-option>
                @for (option of options.state; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu fieldKey="state" fieldLabel="State" test-id="action-menu-state" [auditable]="subject" />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Sex</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.sex | titlecase }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="sex" test-id="sex">
                <mat-option value="">Select Sex</mat-option>
                @for (option of options.sex; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu fieldKey="sex" fieldLabel="Sex" test-id="action-menu-sex" [auditable]="subject" />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Cohort</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.cohort | titlecase }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="cohort" test-id="cohort">
                <mat-option value="">Select Cohort</mat-option>
                @for (option of options.cohort; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu fieldKey="cohort" fieldLabel="Cohort" test-id="action-menu-cohort" [auditable]="subject" />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">ML Set</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.mlset | titlecase }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="mlset" test-id="mlset">
                <mat-option value="">Select ML Set</mat-option>
                @for (option of options.mlset; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu fieldKey="mlset" fieldLabel="ML Set" test-id="action-menu-mlset" [auditable]="subject" />
          </div>
        </div>
      }
      @if (type === 'human' || !type) {
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Race</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.race }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="race" test-id="race">
                <mat-option value="">Select Race</mat-option>
                @for (option of options.race; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu fieldKey="race" fieldLabel="Race" test-id="action-menu-race" [auditable]="subject" />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Ethnicity</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.ethnicity }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="ethnicity" test-id="ethnicity">
                <mat-option value="">Select Ethnicity</mat-option>
                @for (option of options.ethnicity; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu
              fieldKey="ethnicity"
              fieldLabel="Ethnicity"
              test-id="action-menu-ethnicity"
              [auditable]="subject"
            />
          </div>
        </div>
      }
      @if (type === 'animal' || !type) {
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Species</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.species | titlecase }}</span>
            }
            @if (permissions.editMetadata) {
              <mat-select formControlName="species" test-id="species">
                <mat-option value="">Select Species</mat-option>
                @for (option of options.species; track option) {
                  <mat-option [attr.test-id]="'option-' + option.value" [value]="option.value">
                    {{ option.label || (option.value | titlecase) }}
                  </mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu
              fieldKey="species"
              fieldLabel="Species"
              test-id="action-menu-species"
              [auditable]="subject"
            />
          </div>
        </div>
        <div class="info-row">
          <span class="field-tooltip"></span>
          <span class="field-label">Strain</span>
          <div class="field-value">
            @if (!permissions.editMetadata) {
              <span>{{ subject.strain }}</span>
            }
            @if (permissions.editMetadata) {
              <input
                autocomplete="off"
                formControlName="strain"
                placeholder="Subject Strain"
                test-id="strain"
                type="text"
              />
            }
          </div>
          <div class="field-error"></div>
          <div class="field-action-menu">
            <fw-action-menu fieldKey="strain" fieldLabel="Strain" test-id="action-menu-strain" [auditable]="subject" />
          </div>
        </div>
      }
    </form>
  </div>
}
